import { Spin } from "antd";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/modules/auth/store/auth.store";

interface ProtectedRouteProps {
	children: ReactNode;
	allowedRoles?: number[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
	const location = useLocation();
	const { isAuthenticated, isLoading, user } = useAuthStore();

	if (isLoading) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<Spin size="large" />
			</div>
		);
	}

	if (!isAuthenticated) {
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	if (allowedRoles && user?.role && !allowedRoles.includes(user.role.id)) {
		return <Navigate to="/dashboard" replace />;
	}

	return <>{children}</>;
}
